import { api } from '../../api/instance';

export const catalogService = {
  getCatalog(params) {
    const payload = { category_id: (params && params.categoryId) || '', q: (params && params.q) || '' };
    return api.post('v3/catalog', payload);
  },
  getProductDetails(id) {
    return api.get(`v3/catalog/items/${id}`);
  },
  search(q) {
    return api.post('v3/catalog/search', { q });
  },
};



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/stores/catalogStore/service.js